import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Category, Item } from '../../menu.interfaces';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    standalone: false
})
export class MenuItemComponent implements OnInit, OnChanges {

  @Input() categories: Category[] = [];

  public readonly DEFAULT_IMAGE_PATH = 'default.png';
  public readonly IMAGES_PATH = 'assets/images/thumb/pratos/';
  public readonly enablePicture = environment.features.enableMenuItemPicture;

  public filteredCategories: Category[] = [];
  public modalItems: Item[] = [];
  public activeModalIndex = -1;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['categories']){
      this.filteredCategories = this.categories.filter(this.checkCategoryHasAvailableItems);
      this.modalItems = this.filteredCategories.flatMap((category) => category.items.filter((item) => !item.indisp));
    }
  }

  trackById(_index: number, category: Category | Item) {
    return category.id;
  }

  openModal(item: Item): void {
    const index = this.modalItems.indexOf(item);

    if (index < 0) {
      return;
    }

    this.activeModalIndex = index;
  }

  closeModal(): void {
    this.activeModalIndex = -1;
  }

  onImageError(event: Event): void {
    const image = event.target as HTMLImageElement | null;

    if (!image) {
      return;
    }

    // Prevent infinite loops if the fallback image cannot be loaded.
    image.onerror = null;
    image.src = this.IMAGES_PATH + this.DEFAULT_IMAGE_PATH;
  }

  private checkCategoryHasAvailableItems(category: Category){
    return category.items.some(( item ) => !item.indisp )
  }
}
